import { styled } from 'stitches.config'

export const BorderRoot = styled('div', {
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  lineHeight: 0,
  display: 'block',

  '& svg': {
    position: 'relative',
    display: 'block',
  },

  variants: {
    invert: {
      true: {
        transform: 'rotate(180deg)'
      }
    },
    bottom: {
      true: {
        transform: 'rotateY(180deg)'
      }
    }
  }
})